module.exports = __webpack_public_path__ + "img/click-active.26934928.png";